import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MainService } from 'src/app/app.service';
import { SmartReviewApiService } from '../../core/api/smart-review-api.service';
import { SmartReviewGate, SmartReviewGateKey, SmartReviewGatesResponse } from '../../core/interfaces/gate.interface';

/**
 * Controle dos gates de sistema do Smart Review (admin/operação):
 * pausar/retomar entrada de novos pedidos e workers da fila.
 */
@Injectable()
export class GatesService extends SmartReviewApiService {
  constructor(http: HttpClient, mainService: MainService) {
    super(http, mainService);
  }

  getAdminGates(): Observable<SmartReviewGate[]> {
    return this.http
      .get<SmartReviewGatesResponse>(`${this.apiURL}/admin/gates`, { headers: this.jsonHeaders })
      .pipe(map(response => response?.gates ?? []));
  }

  updateAdminGate(key: SmartReviewGateKey, paused: boolean): Observable<SmartReviewGate> {
    return this.http
      .put<SmartReviewGate>(`${this.apiURL}/admin/gates/${key}`, { paused }, { headers: this.jsonHeaders });
  }
}
